<div class="recommendations">
  <h2 [innerHTML]="textkeyPrefix + 'headline' | translate"></h2>
  @if (anfrage?.userInput?.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_MIETER) {
    <p [innerHTML]="textkeyPrefix + 'subheadline' | translate"></p>
  }
  <ul>
  @for (recommendation of recommendations; track recommendation) {
    <li [innerHTML]="(textkeyPrefix + recommendation) | translate: textPlaceholder"></li>
  }
  </ul>
</div>
